import React, { useEffect } from 'react'
import { HomeautomationTemplate } from '../../templates'
import { ScrollTop } from '../../molecules'

export function Homeautomation() {
    useEffect(() => {
        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    }, [1])
    return (
        <div>
            <ScrollTop />
            <HomeautomationTemplate />            
        </div>
    )
}

